import Vue from 'vue';
import Vuex from 'vuex';
import login from '@/store/login';
import applicant from '@/store/applicant';
// import occupation from '@/store/occupation';
import user from '@/store/user';
import searchTemplate from '@/store/searchTemplate';
import filterSearch from '@/store/filterSearch';
import field from '@/store/field';
import messageTemplates from '@/store/messageTemplates';
import individual_contact from '@/store/individual_contact';
import flash from '@/store/flash';
import jd from '@/store/jd';
import profileJd from '@/store/profileJd';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth: login,
    applicant,
    // occupation,
    jd,
    profileJd,
    user,
    filterSearch,
    field,
    searchTemplate,
    messageTemplates,
    individual_contact,
    flash
  },
});
